import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ServiceDetailPage = lazy(() => import('../pages/service-detail/page'));
const MaternityZenPage = lazy(() => import('../pages/maternity-zen/page'));
const VitalityZenPage = lazy(() => import('../pages/vitality-zen/page'));
const TechnologyPage = lazy(() => import('../pages/technology/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/qui-sommes-nous',
    element: <AboutPage />,
  },
  {
    path: '/nos-services',
    element: <ServicesPage />,
  },
  {
    path: '/service/:slug',
    element: <ServiceDetailPage />,
  },
  {
    path: '/maternity-zen',
    element: <MaternityZenPage />,
  },
  {
    path: '/gestion-du-poids-vitality-zen',
    element: <VitalityZenPage />,
  },
  {
    path: '/technologie-innovation',
    element: <TechnologyPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;